import { render, staticRenderFns } from "./product_page.vue?vue&type=template&id=c48cf1c6&scoped=true&"
import script from "./product_page.vue?vue&type=script&lang=js&"
export * from "./product_page.vue?vue&type=script&lang=js&"
import style0 from "./product_page.vue?vue&type=style&index=0&id=c48cf1c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48cf1c6",
  null
  
)

export default component.exports